import { type ReactElement } from 'react';

import { long5 } from '@spotify-internal/encore-foundation';

const BOWTIE =
  'M60.305 142.774C49.7994 124.578 44.5466 115.48 46.9358 106.563C49.325 97.6469 58.4231 92.3941 76.6193 81.8886L86.2693 76.3171C104.465 65.8115 113.564 60.5587 122.48 62.9479C131.397 65.3371 136.649 74.4352 147.155 92.6314L152.726 102.281C163.232 120.478 168.485 129.576 166.096 138.492C163.706 147.409 154.608 152.662 136.412 163.167L126.762 168.739C108.566 179.244 99.4678 184.497 90.5513 182.108C81.6348 179.719 76.382 170.62 65.8764 152.424L60.305 142.774Z';
const CROSS =
  'M231.658 183.907C248.529 167.036 275.881 167.036 292.752 183.907L305.48 196.635L318.207 183.908C335.078 167.037 362.431 167.037 379.301 183.908C396.172 200.779 396.172 228.131 379.301 245.002L366.574 257.729L379.302 270.457C396.173 287.328 396.173 314.68 379.302 331.551C362.432 348.422 335.079 348.422 318.208 331.551L305.48 318.823L292.751 331.552C275.881 348.423 248.528 348.423 231.657 331.552C214.787 314.681 214.786 287.329 231.657 270.458L244.386 257.729L231.658 245.001C214.787 228.13 214.787 200.778 231.658 183.907Z';
const FLOWER =
  'M571.464 533.655C564.926 533.746 558.16 530.782 552.955 525.706C547.749 520.63 544.615 513.942 544.541 507.404C544.45 500.849 547.426 494.98 552.515 490.798C553.686 489.832 554.858 488.867 556.029 487.901C557.954 486.315 559.879 484.728 561.803 483.141C567.187 480.149 570.946 472.917 570.266 465.243C561.281 483.626 542.258 498.04 519.922 499.522C517.446 499.824 514.969 500.126 512.493 500.427C510.986 500.611 509.479 500.794 507.972 500.978C501.435 501.784 495.132 499.897 490.445 495.314C485.757 490.756 483.069 483.876 482.978 476.606C482.886 469.336 485.399 462.39 489.97 457.714C494.54 453.015 500.794 450.969 507.35 451.61C508.861 451.756 510.372 451.902 511.883 452.048C514.366 452.287 516.85 452.526 519.332 452.765C525.255 454.456 533.028 452.001 537.973 446.092C518.621 452.738 494.975 449.48 478.133 434.733C476.169 433.195 474.205 431.657 472.241 430.12C471.046 429.184 469.85 428.248 468.654 427.313C463.462 423.26 460.339 417.469 460.265 410.914C460.174 404.376 463.138 397.61 468.214 392.404C473.29 387.199 479.979 384.065 486.516 383.991C493.071 383.9 498.94 386.876 503.123 391.964C504.088 393.136 505.054 394.308 506.019 395.479C507.606 397.404 509.193 399.328 510.779 401.253C513.771 406.637 521.004 410.397 528.679 409.716C510.295 400.731 495.88 381.708 494.398 359.372C494.097 356.896 493.795 354.419 493.493 351.943C493.31 350.436 493.126 348.929 492.942 347.422C492.136 340.885 494.024 334.582 498.606 329.895C503.165 325.207 510.044 322.519 517.315 322.427C524.585 322.336 531.531 324.849 536.206 329.42C540.905 333.99 542.951 340.244 542.31 346.8C542.165 348.311 542.018 349.822 541.872 351.333C541.633 353.816 541.394 356.299 541.155 358.782C539.465 364.705 541.92 372.478 547.829 377.423C541.183 358.071 544.44 334.425 559.187 317.583C560.725 315.619 562.263 313.655 563.8 311.691C564.736 310.496 565.672 309.3 566.608 308.104C570.66 302.912 576.452 299.789 583.007 299.715C589.544 299.624 596.31 302.588 601.516 307.664C606.721 312.74 609.855 319.428 609.929 325.966C610.021 332.521 607.045 338.39 601.956 342.572C600.785 343.538 599.612 344.503 598.441 345.469C596.517 347.055 594.592 348.642 592.667 350.229C587.283 353.221 583.525 360.453 584.206 368.128C593.191 349.745 612.212 335.33 634.549 333.848C637.025 333.547 639.502 333.244 641.977 332.943C643.484 332.759 644.992 332.576 646.499 332.392C653.036 331.586 659.338 333.473 664.026 338.056C668.713 342.615 671.401 349.494 671.493 356.764C671.585 364.034 669.071 370.981 664.501 375.656C659.93 380.355 653.676 382.401 647.121 381.76C645.61 381.614 644.098 381.468 642.587 381.322C640.105 381.083 637.621 380.844 635.138 380.605C629.215 378.914 621.444 381.371 616.499 387.279C635.851 380.634 659.495 383.891 676.337 398.637C678.301 400.175 680.265 401.713 682.229 403.25C683.424 404.186 684.621 405.122 685.816 406.057C691.009 410.11 694.131 415.901 694.205 422.456C694.296 428.994 691.332 435.76 686.256 440.966C681.18 446.171 674.492 449.305 667.954 449.379C661.399 449.47 655.53 446.494 651.348 441.406C650.382 440.234 649.417 439.062 648.451 437.891C646.865 435.966 645.278 434.042 643.691 432.117C640.699 426.734 633.468 422.975 625.793 423.656C644.176 432.641 658.591 451.663 660.072 473.999C660.374 476.474 660.676 478.951 660.977 481.427C661.161 482.934 661.345 484.442 661.528 485.948C662.334 492.486 660.447 498.788 655.864 503.476C651.306 508.163 644.426 510.851 637.156 510.943C629.886 511.034 622.94 508.521 618.264 503.95C613.565 499.38 611.519 493.126 612.16 486.57C612.306 485.059 612.453 483.548 612.598 482.037C612.837 479.554 613.076 477.071 613.315 474.588C615.006 468.665 612.55 460.894 606.642 455.948C613.288 475.3 610.03 498.945 595.283 515.787C593.746 517.751 592.208 519.715 590.67 521.679C589.734 522.874 588.799 524.071 587.863 525.266C583.81 530.458 578.019 533.581 571.464 533.655Z';
const HEXAGON =
  'M254.731 434.964C263.897 429.673 275.189 429.673 284.354 434.964L360.555 478.959C369.72 484.25 375.366 494.03 375.366 504.613L375.366 592.602C375.366 603.185 369.72 612.964 360.555 618.256L284.354 662.25C275.189 667.542 263.897 667.542 254.731 662.25L178.531 618.256C169.366 612.964 163.719 603.185 163.719 592.602L163.719 504.613C163.719 494.03 169.366 484.25 178.531 478.959L254.731 434.964Z';

type PathGeometry = {
  type: 'path';
  d: string;
};

type CircleGeometry = {
  type: 'circle';
  cx: number;
  cy: number;
  r: number;
};

export type ChartShape = {
  id: 'bowtie' | 'circle' | 'cross' | 'flower' | 'hexagon';
  viewBox: string;
  geometry: PathGeometry | CircleGeometry;
  assetPlacement: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  textureWindow: {
    x: number;
    y: number;
    width: number;
    height: number;
    transform: string;
  };
  patternId: 'hatch' | 'lines' | 'dots' | 'waves' | 'checker';
  driftClassName:
    | 'shapeDriftOne'
    | 'shapeDriftTwo'
    | 'shapeDriftThree'
    | 'shapeDriftFour'
    | 'shapeDriftFive';
  driftDurationMultiplier: number;
};

export const AMBIENT_DURATION_MILLISECONDS = Number.parseInt(long5, 10);

export const CHART_SHAPES = [
  {
    id: 'bowtie',
    viewBox: '40 56 132 132',
    geometry: { type: 'path', d: BOWTIE },
    assetPlacement: { x: 52, y: 54, width: 226, height: 226 },
    textureWindow: {
      x: 132,
      y: 104,
      width: 146,
      height: 146,
      transform: 'rotate(-42 205 177)',
    },
    patternId: 'hatch',
    driftClassName: 'shapeDriftOne',
    driftDurationMultiplier: 15,
  },
  {
    id: 'circle',
    viewBox: '0 0 142 142',
    geometry: { type: 'circle', cx: 71, cy: 71, r: 71 },
    assetPlacement: { x: 1144, y: 38, width: 166, height: 166 },
    textureWindow: {
      x: 1182,
      y: 72,
      width: 116,
      height: 116,
      transform: 'rotate(15 1240 130)',
    },
    patternId: 'lines',
    driftClassName: 'shapeDriftTwo',
    driftDurationMultiplier: 18,
  },
  {
    id: 'cross',
    viewBox: '214 167 183 183',
    geometry: { type: 'path', d: CROSS },
    assetPlacement: { x: -30, y: 340, width: 188, height: 188 },
    textureWindow: {
      x: 34,
      y: 386,
      width: 118,
      height: 118,
      transform: 'rotate(12 93 445)',
    },
    patternId: 'dots',
    driftClassName: 'shapeDriftThree',
    driftDurationMultiplier: 20,
  },
  {
    id: 'flower',
    viewBox: '459 299 237 236',
    geometry: { type: 'path', d: FLOWER },
    assetPlacement: { x: 1088, y: 362, width: 286, height: 286 },
    textureWindow: {
      x: 1154,
      y: 426,
      width: 188,
      height: 188,
      transform: 'rotate(-15 1248 520)',
    },
    patternId: 'waves',
    driftClassName: 'shapeDriftFour',
    driftDurationMultiplier: 16,
  },
  {
    id: 'hexagon',
    viewBox: '160 430 220 238',
    geometry: { type: 'path', d: HEXAGON },
    assetPlacement: { x: 284, y: 692, width: 198, height: 198 },
    textureWindow: {
      x: 334,
      y: 738,
      width: 138,
      height: 138,
      transform: 'rotate(10 403 807)',
    },
    patternId: 'checker',
    driftClassName: 'shapeDriftFive',
    driftDurationMultiplier: 19,
  },
] as const satisfies readonly ChartShape[];

export const ChartShapeGeometry = ({
  shape,
}: {
  shape: ChartShape;
}): ReactElement =>
  shape.geometry.type === 'path' ? (
    <path d={shape.geometry.d} />
  ) : (
    <circle
      cx={shape.geometry.cx}
      cy={shape.geometry.cy}
      r={shape.geometry.r}
    />
  );
